import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-price-modal',
  template: `
    <h1 mat-dialog-title>Criar Novo Preço</h1>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Valor (R$)</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="price" placeholder="Digite o valor" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Iniciar em</mat-label>
        <input 
          matInput 
          [matDatepicker]="picker" 
          [(ngModel)]="startDate" 
          [min]="minDate"
          placeholder="Selecione a data, clique no ícone do calendário"
          readonly />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <mat-dialog-actions align="end">
      <button mat-button class="cancel-button" (click)="onCancel()">Cancelar</button>
      <button mat-raised-button class="create-button" (click)="onCreate()">Criar</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .full-width { width: 100%; }
    mat-dialog-actions { margin-top: 15px; }
    .create-button {
      background-color: #4CAF50;
      color: white;
    }
    .create-button:hover {
      background-color: #45A049;
    }
    .cancel-button {
      background-color: rgb(146, 0, 0);
      color: white;
    }
    .cancel-button:hover {
      background-color: rgb(175, 12, 0);
    }
  `]
})
export class CreatePriceModalComponent {
  price!: number;
  startDate!: Date;
  minDate: Date;

  ngOnInit(): void {
    const today = new Date();
    this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
  }
  
  constructor(public dialogRef: MatDialogRef<CreatePriceModalComponent>) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    if (this.price > 0 && this.startDate) {
      this.dialogRef.close({
        price: this.price,
        startDate: this.startDate.toISOString().split('T')[0]
      });
    } else {
      alert('Preencha corretamente o valor (maior que 0) e a data.');
    }
  }
}
